import React from 'react';
import { formatRupiahFull } from '../data/financialData';

interface TopExpenseItem {
  account: string;
  amount: number;
}

interface TransactionTableProps {
  items: TopExpenseItem[];
  periodLabel: string;
}

const TransactionTable: React.FC<TransactionTableProps> = ({ items, periodLabel }) => {
  const total = items.reduce((s, x) => s + Math.abs(x.amount), 0);
  return (
    <div className="data-table-card animate-in">
      <div className="data-table-header">
        <div>
          <div className="data-table-title">📋 Top Expenses</div>
          <div style={{ fontSize: '12px', color: 'var(--text-muted)', marginTop: '2px' }}>
            Kategori beban terbesar — {periodLabel}
          </div>
        </div>
      </div>
      <div style={{ overflowX: 'auto' }}>
        <table className="data-table" id="transactions-table">
          <thead>
            <tr>
              <th>Kategori</th>
              <th style={{ textAlign: 'right' }}>Jumlah</th>
              <th style={{ textAlign: 'right' }}>% dari Total</th>
            </tr>
          </thead>
          <tbody>
            {items.map((x, i) => {
              const pct = total > 0 ? (Math.abs(x.amount) / total) * 100 : 0;
              return (
                <tr key={i}>
                  <td><span className="category-badge">{x.account}</span></td>
                  <td style={{ textAlign: 'right' }}>
                    <span className="amount-negative">{formatRupiahFull(x.amount)}</span>
                  </td>
                  <td style={{ textAlign: 'right', color: 'var(--text-secondary)' }}>{pct.toFixed(1)}%</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default TransactionTable;
